import { ReactNode, useEffect } from "react";
import { useSearchParams } from "src/utils/useSearchParams";

interface Props {
  section: string;
  children: ReactNode;
}

export function HighlightSection(props: Props) {
  const params = useSearchParams();
  const highlighted = params.get("highlight");

  useEffect(() => {
    if (highlighted === props.section) {
      const element = document.getElementById(props.section);

      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ block: "start", behavior: "smooth" });
        }, 30);
      }
    }
  }, []);

  return (
    <div className="relative" id={props.section}>
      {highlighted === props.section && (
        <div className="absolute -left-4 top-4 -bottom-2 w-1 rounded-full bg-success" />
      )}
      {props.children}
    </div>
  );
}
